/**
 * O que faz: Envolve o login no cartão branco dividido, com preview do produto à direita.
 * Onde usa: SignInPage, inclusive no estado de verificação da sessão.
 * Conexões: PainelPreviewLogin e o CSS isolado login-gens.css.
 * Tabelas: Nenhuma.
 * Data: 19/09/2026.
 */
import { ReactNode } from 'react';
import { PainelPreviewLogin } from '@/components/auth/PainelPreviewLogin';
import '@/styles/login-gens.css';

interface TelaLoginLayoutProps {
  children: ReactNode;
}

export function TelaLoginLayout({ children }: TelaLoginLayoutProps) {
  return (
    <div className="login-gens">
      <div className="login-gens-shell">
        <section className="login-gens-form" aria-label="Entrar no Gens CRM">
          {children}
        </section>
        <PainelPreviewLogin />
      </div>
    </div>
  );
}
